const pageTitles = {
  blog: {
    communityArticles: 'osquery | Community Articles',
    default: 'osquery | Blog',
    officialNews: 'osquery | Official News',
  },
  downloads: 'osquery | Downloads',
  home: 'osquery | Easily ask questions about your Linux, Windows, and macOS infrastructure',
  schema: 'osquery | Schema',
}

export default pageTitles
